import {
  formatIncompletePhoneNumber,
  parseIncompletePhoneNumber,
  isValidPhoneNumber
} from 'libphonenumber-js'

export function requiredRule(item, isMsg) {
  return {
    rules: [
      {
        required: true,
        message: isMsg ? item : `${item} is required, Please Check it!`
      }
    ]
  }
}
export function amountRule(item) {
  return {
    normalize: (value, prev) => {
      if (/^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/.test(value) || value === '') {
        return value
      }
      return prev
    },
    rules: [
      {
        required: true,
        message: `${item} is required, Please Check it!`
      }
    ]
  }
}
export function requiredArrayRule(item) {
  return {
    rules: [
      {
        required: true,
        type: 'array',
        min: 1,
        message: `${item} is required, Please Check it!`
      }
    ]
  }
}
export function emailRule(required) {
  return {
    rules: [
      {
        required: !!required,
        type: 'email',
        message: 'Please Check The E-mail Format'
      }
    ]
  }
}

export function intlMobileRule(countryCode, needFormat = true) {
  return {
    validateTrigger: 'onBlur',
    normalize: (value = '', prev = '') => {
      // 调用libphonenumber按国家/地区的格式对输入手机号格式化
      if (value === prev || !needFormat) {
        return value
      }
      if (countryCode === 'AE' && value.length === 1 && value !== '0') {
        // UAE的手机号自动补0，以便匹配格式化
        return `0${value}`
      }
      if (parseIncompletePhoneNumber(value) === parseIncompletePhoneNumber(prev)) {
        return parseIncompletePhoneNumber(value)
      }
      return formatIncompletePhoneNumber(value, countryCode)
    },
    rules: [
      {
        required: true,
        message: 'Please enter the valid mobile number'
      },
      {
        validator: (rules, value, callback) => {
          // 调用libphonenumber做手机号格式的校验
          const errors = []
          if (!isValidPhoneNumber(value, countryCode)) {
            errors.push(new Error('Please enter the valid mobile number'))
          }
          callback(errors)
        }
      }
    ]
  }
}
